function TestimonialsController(){
	this.className			= "TestimonialsController";
	this.view				= false; //"example";
	this.glob				= ["/testimonials**", "/testimonials?*"];
    this.log                = false;
}

TestimonialsController.inheritsFrom( PageController );
TestimonialsController.prototype.setup = function(onComplete){
	if(this.isSetup) return;

	this.$body				= $('body');

	this.isSetup = true;
}

TestimonialsController.prototype.swap = function(){
    if(!this.isSetup) this.setup();
    this.$page  = this.$body.find('.js-page');
    this.$popup = this.$page.find('.js-testimonial-popup');
    this.$popupClose = this.$popup.find('.js-close');
    this.$popupContent = this.$popup.find('.js-content');
    this.$popupBackground = this.$popup.find('.background');

    $('.testimonial-content').off('click').on("click", (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.disableScroll();

        const $this = $(e.currentTarget);
        this.$popup.find('.tp-content').html($this.attr('data-content'));
        this.$popup.find('.tp-credit').html($this.find('.testimonial-credit').text());
        this.$popup.addClass('show');
	});

    this.$popupClose.off("click").on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closePopup();
    });

    this.$popupBackground.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closePopup();
    });

    // Trigger on Keypress
    this.$body.on("keydown",this.keydownDelegate);
    this.keydownDelegate = (e) => {
        // Keypress: Escape
        if(e.which === 27) {
            e.preventDefault();
            e.stopPropagation();
            this.closePopup();
        }
    };

    return true;
}

TestimonialsController.prototype.closePopup = function(onComplete){
    this.$popup.removeClass('show');
    this.enableScroll();
}
TestimonialsController.prototype.on = function(onComplete){
    return true;
}

TestimonialsController.prototype.onResize = function() {
    return true;
}

TestimonialsController.prototype.off = function(onComplete){
    $('.testimonial-content').off('click touchstart');
    this.$popup.removeClass('testimonial-popup');
}

TestimonialsController.prototype.disableScroll = function () { 
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop; 
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function() { 
        window.scrollTo(scrollLeft, scrollTop); 
    }; 
} 

TestimonialsController.prototype.enableScroll = function () { 
    window.onscroll = function() {}; 
} 